module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_completed_small-75f7e30e98a5746434c5b75757267864.svg";